import React, { useEffect, useState } from "react";
import { useRef } from "react";
import {
    FormGroup,
    FormControlLabel,
    Checkbox,
    Typography,
    Tooltip,
    IconButton,
} from "@mui/material";
import Grid from "@mui/material/Grid";
import { styled } from "@mui/material/styles";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import axiosInstance from "../../../lib/axios";
import axios from "axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import { useNavigate, useLocation } from "react-router-dom";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import CustomAutocomplete from "../../AutoComplete/AutoComplete";
import checkAndLock from "../../../GlobalFunction/checkAndLock";
import UnLock from "../../../GlobalFunction/UnLock";
import CrudButtons from "../../../GlobalFunction/CrudButtons";
import ReportTable from "../../../atoms/ReportFolder/ReportTable";
import { useReactToPrint } from "react-to-print";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import SendIcon from "@mui/icons-material/Send";
import { now } from "lodash";
import axiosInstanceForPG from "../../../lib/axiosFormPG";
import { jsPDF } from "jspdf";
import moment from "moment";
import logo from '../../../../src/assets/Images/Clanbridge-logo.png2.png';
import TopupPrint from "./TopupPrint";
import {selectGatewayType} from '../../../redux/propertySlice';
import { useSelector } from "react-redux";

const CustomTextField = styled(TextField)(({ theme }) => ({
    "& .MuiFilledInput-root": {
        backgroundColor: "transparent",
        border: "1px solid #e0e0e0",
        borderRadius: "4px",
    },
    "& .Mui-focused": {
        borderColor: "#673ab7",
    },
    "& .MuiFilledInput-root.Mui-focused": {
        border: "1px solid #673ab7",
    },
}));

const columns = [
    { id: "RowNum", label: "S.No.", minWidth: 170 },
    { id: "TopUpDt", label: "TopUpDt", minWidth: 100 },
    { id: "MstTopUpId", label: "MstTopUpId", minWidth: 100 },
    { id: "PropId", label: "PropId", minWidth: 100 },
    { id: "ResidentId", label: "ResidentId", minWidth: 170 },
    { id: "BookId", label: "BookId", minWidth: 100 },
    { id: "PytAdvId", label: "PytAdvId", minWidth: 100 },
    { id: "RoomBedId", label: "RoomBedId", minWidth: 100 },
    { id: "TopUpDays", label: "TopUpDays", minWidth: 100 },
    { id: "TopUpAmt", label: "TopUpAmt", minWidth: 100 },
    { id: "Remark", label: "Remark", minWidth: 100 },
    { id: "Status", label: "Status", minWidth: 50 },
];

const initialFormData = {
    TopUpDt: null,
    MstTopUpId: "",
    PropId: "",
    ResidentId: "",
    BookId: "",
    PytAdvId: "",
    RoomBedId: "",
    TopUpDays: 0,
    TopUpAmt: "0.00",
    Remark: "",
    Status: "",
    PropName: "",
    ResidentName: "",
    BookNo: "",
    RoombedName: "",
    PytAdvNo: "",
    TopupID: "",
    RoomTypeName: "",
    MobileNo: "",
    Email: "",
    BookingNo: "",
};

const TrnTopUp = () => {
    const [formData, setFormData] = useState(initialFormData);
    const [UserId, setUserId] = useState(sessionStorage.getItem('UserId'));
    const [PropId, setPropId] = useState(-1);
    const [ResidentId, setResidentId] = useState(-1);
    const [BookId, setBookId] = useState(-1);
    const [PytAdvId, setPytAdvId] = useState(-1);
    const [RoomBedId, setRoomBedId] = useState(-1);
    const [RoomTypeId, setRoomTypeId] = useState(-1);
    const [Clearall, setClearall] = useState(null);
    const [Topupsdrp, setTopupsdrp] = useState([]);
    const [error, setError] = useState({
        TopUpDt: false,
        MstTopUpId: false,
        PropId: false,
        ResidentId: false,
        BookId: false,
        PytAdvId: false,
        RoomBedId: false,
        TopUpDays: false,
        TopUpAmt: false,
        Remark: false,
        Status: false,
    });

    const navigate = useNavigate();
    const [isFormDisabled, setIsFormDisabled] = useState(true);
    const location = useLocation();
    const [currentTrnTopUpId, setCurrentTrnTopUpId] = useState(null);
    const [mode, setMode] = useState("view");
    const [lastTrnTopUpId, setLastTrnTopUpId] = useState(null);
    const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
    const [Status, setStatus] = useState("1");

    // const UserId = sessionStorage.getItem("UserId");
    const contentRef = useRef(null);
    const handlePrint = useReactToPrint({ contentRef });
    const MstTopUpIdRef = useRef(null);
    const PropIdRef = useRef(null);
    const BookIdRef = useRef(null);
    const PytAdvIdRef = useRef(null);
    const RoomBedIdRef = useRef(null);
    const TopUpAmtRef = useRef(null);
    const RemarkRef = useRef(null);
    const RoomBedTypeRef = useRef(null);
    const [autoMail, setAutoMail] = useState(true);
    const gatewayType = useSelector(selectGatewayType);

    const handleDateChange = (date) => {
        setFormData({
            ...formData,
            TopUpDt: date,
        });
    };

    const isFieldDisabled = (fieldName) => {
        if (formData.inquiryNo && mode === "add") {
            if (fieldName === "followupDate" || fieldName === "followRemark") {
                return false;
            }
            return true;
        }
        return isFormDisabled;
    };

    // useEffect(() => {
    //     if (location.state && location.state.TrnTopUpId) {
    //         setCurrentTrnTopUpId(location.state.TrnTopUpId);
    //         fetchcolData(location.state.TrnTopUpId);
    //         setMode("view");
    //     } else {
    //         setMode("add");
    //         setIsFormDisabled(false);
    //         setFormData((prev) => ({ ...prev, TopUpDt: new Date() }));
    //     }
    // }, [location]);

    useEffect(() => {
        const searchParams = new URLSearchParams(location.search);
        const trnTopUpId = searchParams.get("TrnTopUpId");
        const modeFromURL = searchParams.get("mode");

        if (trnTopUpId) {
            setCurrentTrnTopUpId(trnTopUpId);
            fetchcolData(trnTopUpId);
            setMode(modeFromURL || "view");
        } else {
            setMode("add");
            setIsFormDisabled(false);
            setFormData((prev) => ({ ...prev, TopUpDt: new Date() }));
        }
    }, [location]);

    const fetchcolData = async (id, flag) => {
        try {
            const response = await axiosInstance.post(`TrnTopUp/RetriveTrnTopUp`, {
                TrnTopUpId: parseInt(id),
                Flag: flag,
                "CreatedBy": UserId,
            });

            if (response.data.Status === 0 && response.data.responseStatusCode === 1) {
                const colData = response.data.Data[0];
                const topUpDate = colData.TopUpDt ? new Date(colData.TopUpDt) : null;
                setFormData({
                    TopUpDt: topUpDate,
                    MstTopUpId: colData.MstTopUpId || "",
                    PropId: colData.PropId || "",
                    ResidentId: colData.ResidentId || "",
                    BookId: colData.BookId || "",
                    PytAdvId: colData.PytAdvId || "",
                    RoomBedId: colData.RoomBedId || "",
                    TopUpDays: colData.TopUpDays || 0,
                    TopUpAmt: colData.TopUpAmt || "0.00",
                    Remark: colData.Remark || "",
                    Status: colData.Status || "",
                    BookNo: colData.BookNo || "",
                    PytAdvNo: colData.PytAdvNo || "",
                    RoombedName: colData.RoombedName || "",
                    ResidentName: colData.ResidentName || "",
                    RoomTypeName: colData.RoomTypeName || "",
                    PropName: colData.PropName || "",
                    currentTrnTopUpId: colData.TrnTopUpId || "",
                    Email: colData.Email || "",
                    MobileNo: colData.MobileNo || "",
                    BookingNo: colData.BookingNo || "",
                });

                setStatus(colData.Status.toString() || "0");
                setIsFormDisabled(true);
                setCurrentTrnTopUpId(colData.TrnTopUpId);
                setPropId(colData.PropId);
            } else if (response.data.Status === 1 && response.data.responseStatusCode === 2) {
                toast.info(response.data.Message);
            } else {
                toast.info("Failed to fetch Transaction TopUp data");
            }
        } catch (error) {
            toast.error("Error fetching TopUp data. Please try again.");
        }
    };

    const fetchdeletecolData = async (id, flag, actionby) => {
        try {
            const response = await axiosInstance.post(`TrnTopUp/DeleteTrnTopUp`, {
                TrnTopUpId: parseInt(id),
                Flag: flag,
                ActionBy: actionby,
            });

            if (response.data.Status === 0 && response.data.responseStatusCode === 1) {
                const colData = response.data.Data[0];
                const topUpDate = colData.TopUpDt ? new Date(colData.TopUpDt) : null;

                setFormData({
                    TopUpDt: topUpDate,
                    MstTopUpId: colData.MstTopUpId,
                    PropId: colData.PropId,
                    ResidentId: colData.ResidentId,
                    BookId: colData.BookId,
                    PytAdvId: colData.PytAdvId,
                    RoomBedId: colData.RoomBedId,
                    TopUpDays: colData.TopUpDays,
                    TopUpAmt: colData.TopUpAmt,
                    Remark: colData.Remark,
                    Status: colData.Status,
                    BookNo: colData.BookNo,
                    PytAdvNo: colData.PytAdvNo,
                    RoombedName: colData.RoombedName,
                    ResidentName: colData.ResidentName,
                    RoomTypeName: colData.RoomTypeName,
                    PropName: colData.PropName,
                    currentTrnTopUpId: colData.TrnTopUpId,
                });

                setStatus(colData.Status.toString() || "0");
                setIsFormDisabled(true);
                setCurrentTrnTopUpId(colData.TrnTopUpId);
                setPropId(colData.PropId);
            } else if (response.data.Status === 1 && response.data.responseStatusCode === 2) {
                toast.info(response.data.Message);
            } else {
                toast.info("Failed to fetch Transaction TopUp data");
            }
        } catch (error) {
            toast.error("Error fetching TopUp data. Please try again.");
        }
    };

    const handlePrevious = async () => {
        if (currentTrnTopUpId && currentTrnTopUpId > 1) {
            await fetchcolData(currentTrnTopUpId, "P");
        }
    };

    const handleNext = async () => {
        if (currentTrnTopUpId) {
            await fetchcolData(currentTrnTopUpId, "N");
        }
    };

    const fetchTopups = async (RoomTypeId, PropId) => {
        try {
            const response = await axiosInstance.post(`MstTopup/getMstTopupdrp`, {
                RoomTypeId: RoomTypeId,
                Flag: "",
                PropId: PropId,
            });
            if (response.data.Status === 0 && response.data.responseStatusCode === 1 && response.data.Data) {
                setTopupsdrp(response.data.Data);
                setFormData((prevState) => ({
                    ...prevState,
                    TopUpDays: response.data.Data[0]?.TopUpDays || 0,
                    TopUpAmt: response.data.Data[0]?.TopUpAmt || '0.00',
                }));
            } else {
                toast.error("Failed to fetch Topup");
            }
        } catch (error) {
            toast.error("Error fetching Topup. Please try again.");
        }
    };

    const handleTopupsChange = async (e) => {
        let val = e.target.value;
        try {
            const selectedTopup = Topupsdrp.find((obj) => obj.TopupID === val);
            if (selectedTopup) {
                setFormData((prevState) => ({
                    ...prevState,
                    MstTopUpId: selectedTopup.TopupID,
                    TopUpAmt: selectedTopup.TopupAmt || selectedTopup.TopUpAmt || '0.00',
                    TopUpDays: selectedTopup.Topupdays || selectedTopup.Topupdays || 0,
                }));
            }
        } catch (error) {
            toast.error("Error fetching handleTopupsChange data:", error);
        }
    };

    const handleBookNoChange = async (e) => {
        let val = e.target.value.trim();
        setFormData((prevState) => ({
            ...prevState,
            BookNo: val,
        }));
        if (val.length >= 8) {
            try {
                const response = await axiosInstance.post(
                    `TrnBooking/GetTrnBookingDashBoard`,
                    {
                        start: 1,
                        PageSize: 1,
                        SearchText: '',
                        Flag:'',
                        MobileNo :'',
                        BookNo:val,
                        PropId:1,
                    }
                );
                if (response.data.Status === 0) {
                    const restId = response.data.Data[0].ResidentId;
                    setResidentId(restId);

                    const BkId = response.data.Data[0].BookId;
                    setBookId(BkId);
                    const PrId = response.data.Data[0].PropId;
                    setPropId(PrId);
                    const PyId = response.data.Data[0].PytAdvId;
                    setPytAdvId(PyId);
                    const RmBedId = response.data.Data[0].RoomBedId;
                    setRoomBedId(RmBedId);
                    const RmTypeId = response.data.Data[0].RoomTypeId;
                    setRoomTypeId(RmTypeId);

                    if (RmTypeId > 1) {
                        fetchTopups(RmTypeId, PrId);
                    }

                    setFormData((prevState) => ({
                        ...prevState,
                        ResidentName: response.data.Data[0].ResidentName,
                        PytAdvNo: response.data.Data[0].PytAdvNo,
                        RoombedName: response.data.Data[0].RoombedName,
                        PropName: response.data.Data[0].PropName,
                        BookNo: response.data.Data[0].BookNo,
                        RoomTypeName: response.data.Data[0].RoomTypeName,
                        ResidentId: response.data.Data[0].ResidentId,
                        PytAdvId: response.data.Data[0].PytAdvId,
                        RoomBedId: response.data.Data[0].RoomBedId,
                        PropId: response.data.Data[0].PropId,
                        BookId: response.data.Data[0].BookId,
                        RoomTypeId: response.data.Data[0].RoomTypeId,
                    }));
                } else {
                    toast.info("Booking Doesn't Exist On This Number");
                    setBookId(-1);
                }
            } catch (error) {
                toast.error("Error fetching Booking data:", error);
            }
        }
    };

    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setFormData((prevState) => ({
            ...prevState,
            [name]: value,
        }));

        if (name === "TrnTopUp" && value !== "") {
            setTimeout(() => {
                MstTopUpIdRef.current.focus();
            }, 100000);
        }
    };

    const handleKeyPress = (event) => {
        if (event.key === "Enter") {
            if (event.target === MstTopUpIdRef.current) {
                PropIdRef.current.focus();
            } else if (event.target === PropIdRef.current) {
                BookIdRef.current.focus();
            } else if (event.target === BookIdRef.current) {
                RoomBedIdRef.current.focus();
            } else if (event.target === RoomBedIdRef.current) {
                PytAdvIdRef.current.focus();
            } else {
                PytAdvIdRef.current.focus();
            }
        }
    };

    const handleChangeStatus = (event) => {
        const updatedStatus = event.target.checked ? "1" : "0";
        setStatus(updatedStatus);
    };

    const handleAutoMail = (event) => {
        setAutoMail(event.target.checked);
    };

    const handleSave = async () => {
        let hasError = false;

        if (!formData.TopUpAmt) {
            toast.error("TopUpAmt is required");
            setError((prev) => ({ ...prev, TopUpAmt: true }));
            hasError = true;
        } else {
            setError((prev) => ({ ...prev, TopUpAmt: false }));
        }

        if (!formData.BookId) {
            toast.error("Book Id is required");
            setError((prev) => ({ ...prev, BookId: true }));
            hasError = true;
        } else {
            setError((prev) => ({ ...prev, BookId: false }));
        }

        if (!formData.RoomBedId) {
            toast.error("RoomBedId is required");
            setError((prev) => ({ ...prev, RoomBedId: true }));
            hasError = true;
        } else {
            setError((prev) => ({ ...prev, RoomBedId: false }));
        }

        if (hasError) {
            return;
        }

        try {
            const payload = {
                TopUpDt: formData.TopUpDt || new Date(),
                MstTopUpId: formData.MstTopUpId,
                PropId: parseInt(formData.PropId),
                ResidentId: parseInt(formData.ResidentId),
                BookId: parseInt(formData.BookId),
                PytAdvId: parseInt(formData.PytAdvId),
                RoomBedId: parseInt(formData.RoomBedId),
                TopUpDays: 10,
                TopUpAmt: formData.TopUpAmt,
                Remark: formData.Remark,
                Status: Status,
                RoomTypeId: parseInt(formData.RoomTypeId),
            };

            let response;
            if (mode === "edit") {
                payload.TrnTopUpId = currentTrnTopUpId;
                payload.UpdatedBy = parseInt(UserId, 10);
                response = await axiosInstance.patch("TrnTopUp/UpdateTrnTopUp", payload);
            } else {
                payload.CreatedBy = parseInt(UserId, 10);
                response = await axiosInstance.post("TrnTopUp/InsertTrnTopUp", payload);
            }

            if (response.data.Status === 0 && response.data.responseStatusCode === 1) {
                toast.success(response.data.Message);
                if (mode === "add") {
                    setLastTrnTopUpId(response.data.Data);
                    await fetchcolData(response.data.Data);
                    setMode("view");
                    setIsFormDisabled(true);
                    setCurrentTrnTopUpId(response.data.Data);

                    if (autoMail) {
                        await handleSentEmailLink();
                    }
                } else {
                    await UnLock(currentTrnTopUpId, "TrnTopUp", "TrnTopUpId");
                    setMode("view");
                }
                setIsFormDisabled(true);
            } else {
                toast.info(response.data.Message || "Operation failed");
            }
        } catch (error) {
            toast.error("Error saving/updating TopUp. Please try again.");
        }
    };

    const handleEdit = async () => {
        let Flag = await checkAndLock(currentTrnTopUpId, "TrnTopUp", "TrnTopUpId");
        switch (Flag) {
            case 0:
                setMode("edit");
                setIsFormDisabled(false);
                break;
            case 1:
                toast.info("Record Already Locked", { autoClose: 500 });
                break;
            case 2:
                toast.info("Record Failed To Locked", { autoClose: 500 });
                break;
            default:
                toast.info("Something Went Wrong", { autoClose: 500 });
        }
    };

    const handleAdd = () => {
        setFormData({
            TopUpDt: new Date(),
            MstTopUpId: "",
            PropId: "",
            ResidentId: "",
            BookId: "",
            PytAdvId: "",
            RoomBedId: "",
            TopUpDays: 0,
            TopUpAmt: "0.00",
            Remark: "",
            Status: "",
            PropName: "",
            ResidentName: "",
            BookNo: "",
            RoombedName: "",
            PytAdvNo: "",
            TopupID: "",
            RoomTypeName: "",
        });

        setPropId(-1);
        setResidentId(-1);
        setBookId(-1);
        setPytAdvId(-1);
        setRoomBedId(-1);
        setRoomTypeId(-1);
        setTopupsdrp([]);
        setStatus("1");
        setClearall(null);
        setMode("add");
        setIsFormDisabled(false);
        setCurrentTrnTopUpId(null);

        setTimeout(() => {
            MstTopUpIdRef.current?.focus();
        }, 0);
    };

    const handleCancel = async () => {
        try {
            await fetchcolData(1, "L");
            await UnLock(currentTrnTopUpId, "TrnTopUp", "TrnTopUpId");
            setStatus("1");
            setMode("view");
            setIsFormDisabled(true);
        } catch (error) {
            toast.error("Error occurred while cancelling. Please try again.");
        }
    };

    const handleExit = () => {
        navigate("/TrnTopUptable");
    };

    const handleDeleteClick = () => {
        setOpenConfirmDialog(true);
    };

    const handleCloseConfirmDialog = () => {
        setOpenConfirmDialog(false);
    };

    const handleConfirmDelete = async () => {
        let Flag = await checkAndLock(currentTrnTopUpId, "TrnTopUp", "TrnTopUpId");
        switch (Flag) {
            case 0:
                setOpenConfirmDialog(false);
                await fetchdeletecolData(currentTrnTopUpId, "D", parseInt(UserId, 10));
                await fetchcolData(currentTrnTopUpId, "N");
                setMode("view");
                setIsFormDisabled(true);
                break;
            case 1:
                toast.info("Record Already Locked", { autoClose: 500 });
                break;
            case 2:
                toast.info("Record Failed To Locked", { autoClose: 500 });
                break;
            default:
                toast.info("Something Went Wrong", { autoClose: 500 });
        }
    };

    const buttonSx = {
        backgroundColor: "#635bff",
        borderRadius: "5px",
        padding: "5px",
        margin: { xs: "0px 5px", sm: "0px 5px" },
        "&:hover": {
            backgroundColor: "#1565c0",
            cursor: "pointer",
        },
        minWidth: { xs: "40px", sm: "40px", md: "60px" },
        "&:disabled": {
            backgroundColor: "rgba(0, 0, 0, 0.12)",
            color: "rgba(0, 0, 0, 0.26)",
            boxShadow: "none",
        },
    };

    // Add this helper function
    async function getImageDataFromURL(url) {
        return new Promise((resolve) => {
            const img = new Image();
            img.crossOrigin = "Anonymous";
            img.onload = function () {
                const canvas = document.createElement("canvas");
                canvas.width = img.width;
                canvas.height = img.height;
                const ctx = canvas.getContext("2d");
                ctx.drawImage(img, 0, 0);
                resolve(canvas.toDataURL("image/png"));
            };
            img.src = url;
        });
    };

    const handleSentEmailLink = async () => {
    if (!formData.ResidentName || !formData.TopUpAmt || !formData.PytAdvNo || !formData.Email) {
        toast.error("Required data (Resident Name, TopUp Amount, Payment Advice No, or Email) is missing for sending email");
        return;
    }

    try {
        const userId = parseInt(sessionStorage.getItem('UserId'));
        const baseUrl = window.location.origin;
        const currentDateTime = moment().format("DD-MM-YYYY HH:mm:ss");
        const safeTimestamp = moment().format("YYYYMMDD_HHmmss");
        
        // const propertyData = PropertyDrp?.find(p => p.Id === parseInt(formData.PropId));
        // const gatewayType = propertyData?.GateWay_Type || gatewayType || 'CashFree';
        let paymentRequest = null;
        let paymentResponse = null;

        if (gatewayType === 'CashFree') {
            const paymentDetails = {
                customer_details: {
                    customer_email: formData.Email,
                    customer_name: formData.ResidentName,
                    customer_phone: formData.MobileNo || ""
                },
                link_amount: parseFloat(formData.TopUpAmt) || 0,
                link_auto_reminders: true,
                link_currency: "INR",
                link_expiry_time: "2026-06-09T15:04:05+05:30",
                link_id: `Testing9062026`,
                link_meta: {
                    notify_url: `${process.env.REACT_APP_API_URL}CashFreepayment-success/`,
                    return_url: `${process.env.REACT_APP_API_URL}CashFreepayment-success/`,
                    upi_intent: false
                },
                link_minimum_partial_amount: parseFloat(formData.TopUpAmt) || 0,
                link_notes: {
                    key_1: "CashFreepay",
                    key_2: "linkCashfree"
                },
                link_notify: {
                    send_email: false,
                    send_sms: true
                },
                link_partial_payments: true,
                link_purpose: 'Payment',
                ResidentId: parseInt(formData.ResidentId),
                Flag: "Active",
                Remark: "Testing",
                TrjType: "TrnPytAdv",
                TrjDocNo: formData.PytAdvNo,
                TrjDocId: parseInt(formData.PytAdvId) || 0,
                cf_payment_id: "",
                payment_status: "",
                PropId: parseInt(formData.PropId) || 0,
            };

            const response = await axiosInstanceForPG.post(`PaymentGatewayLog/CreateCashFreeLink`, paymentDetails);
            let paymentData = response.data;

            if (typeof paymentData === 'string') {
                try {
                    paymentData = JSON.parse(paymentData);
                } catch {
                    throw new Error("Invalid payment response format");
                }
            }

            paymentResponse = paymentData;

            if (paymentData.Status === 0 && paymentData.Message === "Payment Link Already Sent!" && paymentData.Data) {
                paymentRequest = {
                    longurl: paymentData.Data,
                    id: '',
                    phone: formData.MobileNo,
                    email: formData.Email,
                    buyer_name: formData.ResidentName,
                    amount: formData.TopUpAmt,
                    purpose: 'payment',
                    expires_at: '',
                    status: 'Reused',
                    send_sms: false,
                    send_email: false,
                    sms_status: '',
                    email_status: '',
                    shorturl: paymentData.Data,
                    redirect_url: `${baseUrl}/payment-success`,
                    webhook: '',
                    allow_repeated_payments: false,
                    created_at: '',
                    modified_at: '',
                };
            } else if (paymentData.link_url) {
                paymentRequest = {
                    longurl: paymentData.link_url,
                    id: paymentData.link_id,
                    phone: paymentData.customer_details?.customer_phone || formData.MobileNo,
                    email: paymentData.customer_details?.customer_email || formData.Email,
                    buyer_name: paymentData.customer_details?.customer_name || formData.ResidentName,
                    amount: paymentData.link_amount || formData.TopUpAmt,
                    purpose: paymentData.link_purpose || 'payment',
                    expires_at: paymentData.link_expiry_time || '',
                    status: paymentData.link_status || 'Active',
                    send_sms: paymentData.link_notify?.send_sms || false,
                    send_email: paymentData.link_notify?.send_email || false,
                    sms_status: '',
                    email_status: '',
                    shorturl: paymentData.shorturl || paymentData.link_url,
                    redirect_url: paymentData.link_meta?.return_url || `${baseUrl}/payment-success`,
                    webhook: '',
                    allow_repeated_payments: paymentData.allow_repeated_payments || true,
                    created_at: paymentData.link_created_at || '',
                    modified_at: paymentData.link_modified_at || '',
                };
            } else {
                toast.error("No valid payment link received");
                return;
            }

        } else if (gatewayType === 'Instamojo') {
            const paymentDetails = {
                purpose: `TopUp Payment, # ${formData.PytAdvNo}`,
                amount: parseFloat(formData.TopUpAmt) || 0,
                buyer_name: formData.ResidentName || '',
                email: formData.Email || '',
                phone: formData.MobileNo || '',
                redirect_url: `${baseUrl}/payment-success`,
                redirecturl: `${baseUrl}/payment-success/`,
                webhook_url: '',
                ResidentId: parseInt(formData.ResidentId),
                TrjDocId: parseInt(formData.PytAdvId) || 0,
                TrjType: "TrnTopUp",
                TrjDocNo: formData.PytAdvNo || '',
                PropId: parseInt(formData.PropId) || 0,
            };

            const response = await axiosInstanceForPG.post(`Payment/CreatePaymentOrder`, paymentDetails);
            let paymentData = response.data;

            if (typeof paymentData === 'string') {
                try {
                    paymentData = JSON.parse(paymentData);
                } catch {
                    throw new Error("Invalid payment response format");
                }
            }

            paymentResponse = paymentData;

            if (paymentData.Status === 0 && paymentData.Message === "Payment Link Already Sent!" && paymentData.Data) {
                paymentRequest = {
                    longurl: paymentData.Data,
                    id: '',
                    phone: formData.MobileNo,
                    email: formData.Email,
                    buyer_name: formData.ResidentName,
                    amount: formData.TopUpAmt,
                    purpose: 'payment',
                    expires_at: '',
                    status: 'Reused',
                    send_sms: false,
                    send_email: false,
                    sms_status: '',
                    email_status: '',
                    shorturl: paymentData.Data,
                    redirect_url: `${baseUrl}/payment-success`,
                    webhook: '',
                    allow_repeated_payments: false,
                    created_at: '',
                    modified_at: '',
                };
            } else if (paymentData.payment_request && paymentData.payment_request.longurl) {
                const pr = paymentData.payment_request;
                paymentRequest = {
                    longurl: pr.longurl,
                    id: pr.id,
                    phone: pr.phone || formData.MobileNo,
                    email: pr.email || formData.Email,
                    buyer_name: pr.buyer_name || formData.ResidentName,
                    amount: pr.amount || formData.TopUpAmt,
                    purpose: pr.purpose || 'payment',
                    expires_at: pr.expires_at || '',
                    status: pr.status || 'Active',
                    send_sms: pr.send_sms || false,
                    send_email: pr.send_email || false,
                    sms_status: pr.sms_status || '',
                    email_status: pr.email_status || '',
                    shorturl: pr.shorturl || pr.longurl,
                    redirect_url: pr.redirect_url || `${baseUrl}/payment-success`,
                    webhook: pr.webhook || '',
                    allow_repeated_payments: pr.allow_repeated_payments || true,
                    created_at: pr.created_at || '',
                    modified_at: pr.modified_at || '',
                };
            } else {
                toast.error("No valid payment link received");
                return;
            }

        } else {
            toast.error(`Unsupported gateway type: ${gatewayType}`);
            return;
        }

        // Step 2: Generate PDF with details
        const doc = new jsPDF();
        let yPos = 20;
        const pageWidth = doc.internal.pageSize.width;
        const margin = 20;

        // Title and property name
        doc.setTextColor(99, 91, 255);
        doc.setFontSize(25);
        doc.text(formData.PropName || "No Property Name Available", pageWidth / 2, yPos, { align: "center" });

        yPos += 10;
        doc.setFontSize(18);
        doc.setTextColor(0);
        doc.text("Transaction Topup", pageWidth / 2, yPos, { align: "center" });

        doc.autoTable({
            startY: yPos + 5,
            head: [[{ content: "Transaction Topup Summary", colSpan: 4, styles: { halign: "left", fillColor: [99, 91, 255], textColor: 255, fontSize: 14, cellPadding: 3 } }]],
            body: [
                [
                    { content: "Advice No", styles: { fontStyle: "bold" } },
                    formData.PytAdvNo || "",
                    { content: "Date Of Issue", styles: { fontStyle: "bold" } },
                    moment().format("DD-MM-YYYY")
                ],
                [
                    { content: "Resident Name", styles: { fontStyle: "bold" } },
                    formData.ResidentName || "",
                    { content: "Mobile No", styles: { fontStyle: "bold" } },
                    formData.MobileNo || "",
                ],
                [
                    { content: "Email", styles: { fontStyle: "bold" } },
                    formData.Email || "",
                    { content: "Booking No", styles: { fontStyle: "bold" } },
                    formData.BookingNo || "",
                ],
                [
                    { content: "Amount", styles: { fontStyle: "bold" } },
                    formData.TopUpAmt || "",
                ],
            ],
            theme: "grid",
            styles: {
                fontSize: 10,
                cellPadding: 3,
                lineColor: [229, 231, 235],
                lineWidth: 0.1,
            },
            alternateRowStyles: {
                fillColor: [249, 250, 251],
            },
            margin: { left: margin, right: margin },
        });

        yPos = doc.lastAutoTable.finalY + 15;

        // Pay Now button
        const buttonText = "Pay Now";
        const paddingX = 12;
        const buttonHeight = 18;

        const textWidth = doc.getStringUnitWidth(buttonText) * doc.internal.getFontSize() / doc.internal.scaleFactor;
        const buttonWidth = textWidth + paddingX * 2;

        const buttonX = (pageWidth - buttonWidth) / 2;
        const buttonY = yPos;

        doc.setFillColor(40, 60, 180);
        doc.setDrawColor(30, 50, 150);
        doc.setLineWidth(0.8);
        doc.roundedRect(buttonX, buttonY, buttonWidth, buttonHeight, 4, 4, 'FD');

        doc.setTextColor(255, 255, 255);
        doc.setFontSize(14);
        doc.setFont('helvetica', 'bold');

        const textX = buttonX + (buttonWidth / 2);
        const textY = buttonY + (buttonHeight / 2) + 5;

        doc.textWithLink(buttonText, textX, textY, {
            url: paymentRequest.longurl,
            align: 'center',
        });

        yPos += 25;

        doc.setFontSize(12);
        doc.setTextColor(0);
        doc.text("Thank you for choosing Clanbridge Living Pvt Ltd", margin, yPos);
        doc.text("For any queries, please contact: support@clanbridgeliving.in", margin, yPos + 5);

        // Export PDF blob & base64
        const pdfBlob = doc.output('blob');
        const pdfBase64 = await new Promise((resolve) => {
            const reader = new FileReader();
            reader.onload = () => resolve(reader.result.split(',')[1]);
            reader.readAsDataURL(pdfBlob);
        });

      
        const cleanedPaymentRequest = {};
        for (const key in paymentRequest) {
            const val = paymentRequest[key];
            if (val !== null && val !== undefined && val !== '') {
                cleanedPaymentRequest[key] = val;
            }
        }

        const paymentLogPayload = {
            ...cleanedPaymentRequest,
            ResidentId: parseInt(formData.ResidentId),
            TrjDocNo: formData.PytAdvNo,
            TrjDocId: parseInt(formData.PytAdvId) || 0,
            TrjType: "TrnTopUp",
            Flag: "Active",
            Remark: "Payment Link for TopUp",
            Gatewaytype: gatewayType,
        };

        await axiosInstance.post('PaymentGatewayLog/InsertPaymentRequestLog', paymentLogPayload, {
            headers: { 'Content-Type': 'application/json' },
        });

        
        const Subject = `Clanbridge Living - Payment Request For TopUp Advice No. [${formData.PytAdvNo}]`;
        const Body = `
            Hey <strong>${formData.ResidentName}</strong>,<br><br>
            We would like to inform you that a top-up payment advice has been created for your tenancy at <strong>${formData.PropName}</strong>.<br><br>
            <strong>Advice No:</strong> ${formData.PytAdvNo}<br>
            <strong>Amount:</strong> ${formData.TopUpAmt}<br>
            <strong>Date Of Issue:</strong> ${currentDateTime}<br><br>
            
            <a href="${paymentRequest.longurl}" target="_blank" style="background-color: #1b29a7; color: white; padding: 4px 10px; text-decoration: none; border-radius: 4px;">Pay Now</a><br><br>
            For any assistance, reach us at <strong>sales@clanbridge.com</strong><br><br>
            Cheers,<br>
            Team Clanbridge
        `;

        const emailRequest = {
            ToEmail: formData.Email ? [formData.Email] : [],
            Subject,
            Body,
            PropId: parseInt(formData.PropId),
            UserId: userId,
            ImgFolderNm: formData.PytAdvNo || "TopUpAdvice",
            DocAttachments: [{
                FileName: `TopUp_Advice_${formData.PytAdvNo}_${safeTimestamp}.pdf`,
                FileContent: `data:application/pdf;base64,${pdfBase64}`,
            }],
            TblName: "TrnTopUp",
            Id: parseInt(formData.PytAdvId) || 0,
        };

        const emailResponse = await axiosInstance.post(`EmailRequest/SendEmail`, emailRequest);

        if (emailResponse.data.Status === 0) {
            toast.success(`Payment Link Sent Successfully for ${formData.PytAdvNo}`, { autoClose: 1000 });
        } else {
            toast.info(emailResponse.data.Message || "Failed to send email", { autoClose: 1000 });
        }

    } catch (error) {
        console.error('Error in handleSentEmailLink:', error);
        toast.error(`Failed to send payment link: ${error.message}`, { autoClose: 1000 });
    }
};

    return (
        <>
            <Box
                className="form-container"
                sx={{ height: { xs: "700px", sm: "550px" } }}
            >
                <ToastContainer />
                <Grid container spacing={1} className="form_grid">
                    <Grid item xs={12} className="form_title"
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            marginTop: "20px",
                            flexDirection: { xs: "column", sm: "row", md: "row" },
                        }}
                    >
                        <Grid
                            sx={{
                                display: "flex",
                                justifyContent: { xs: "center", sm: "flex-start" },
                                marginBottom: { xs: "10px", sm: 0 },
                            }}
                        >
                            <Button
                                variant="contained"
                                size="small"
                                className="three-d-button-previous"
                                onClick={handlePrevious}
                                sx={{
                                    backgroundColor: "#635BFF",
                                    marginRight: "8px",  // Optional, to add spacing between buttons
                                }}
                                disabled={
                                    mode !== "view" ||
                                    !currentTrnTopUpId ||
                                    currentTrnTopUpId === 1
                                }
                            >
                                <KeyboardArrowLeftIcon />
                            </Button>

                            <Button
                                variant="contained"
                                size="small"
                                className="three-d-button-next"
                                onClick={handleNext}
                                sx={{
                                    backgroundColor: "#635BFF",
                                }}
                                disabled={mode !== "view" || !currentTrnTopUpId}
                            >
                                <NavigateNextIcon />
                            </Button>
                        </Grid>

                        <Typography variant="h5"
                            sx={{
                                margin: "Auto",
                                textAlign: { xs: "center", sm: "center" },
                                fontSize: { xs: "24px", sm: "18px", md: "24px" },
                            }}
                        >
                            Transaction TopUp
                        </Typography>

                        <Tooltip title="Send Payment Link" arrow>
                            <span>
                                <IconButton
                                    sx={buttonSx}
                                    disabled={!isFormDisabled}
                                    onClick={handleSentEmailLink}
                                >
                                    <SendIcon sx={{ color: "white" }} />
                                </IconButton>
                            </span>
                        </Tooltip>

                        <Grid sx={{ display: "flex", justifyContent: "end" }}>
                            <CrudButtons
                                moduleName="Transaction TopUp"
                                mode={mode}
                                onAdd={handleAdd}
                                onEdit={handleEdit}
                                onView={handlePrint}
                                onDelete={handleConfirmDelete}
                                onExit={handleExit}
                                onPrevious={handlePrevious}
                                onNext={handleNext}
                                readOnlyMode={isFormDisabled}
                            />
                        </Grid>
                    </Grid>

                    <Grid item xs={12} className="form_field">
                        <Grid container spacing={1} justifyContent="center">
                            <Grid item xs={12} md={3} className="form_field">
                                <TextField
                                    id="BookNo"
                                    name="BookNo"
                                    label="Booking No"
                                    variant="filled"
                                    fullWidth
                                    className="custom-textfield"
                                    value={formData.BookNo}
                                    onChange={handleBookNoChange}
                                    disabled={isFormDisabled}
                                    error={error.BookNo}
                                    helperText={error.BookNo ? "" : ""}
                                    inputRef={BookIdRef}
                                    onKeyDown={handleKeyPress}
                                />
                            </Grid>

                            <Grid item xs={12} md={6} lg={3} className="form_field">
                                <TextField
                                    id="PropId"
                                    name="PropId"
                                    label="Property"
                                    variant="filled"
                                    fullWidth
                                    className="custom-textfield"
                                    value={formData.PropName}
                                    onChange={handleInputChange}
                                    disabled={true}
                                    error={error.PropName}
                                    helperText={error.PropName ? "" : ""}
                                    inputRef={PropIdRef}
                                    onKeyDown={handleKeyPress}
                                />
                            </Grid>

                            <Grid item xs={12} md={3}>
                                <LocalizationProvider dateAdapter={AdapterDateFns}>
                                    <DatePicker
                                        label="TopUp Date"
                                        value={formData.TopUpDt}
                                        onChange={handleDateChange}
                                        disabled={isFieldDisabled("TopUpDt")}
                                        slotProps={{
                                            textField: {
                                                fullWidth: true,
                                                variant: "filled",
                                                className: "custom-textfield",
                                                error: error.TopUpDt,
                                                helperText: error.TopUpDt ? "Date is required" : "",
                                            },
                                        }}
                                        format="dd/MM/yyyy"
                                    />
                                </LocalizationProvider>
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid item xs={12} className="form_field">
                        <Grid container spacing={1} justifyContent="center">
                            <Grid item xs={12} md={3} className="form_field">
                                <TextField
                                    id="RoomBedType"
                                    name="RoomBedType"
                                    label="Room Type"
                                    variant="filled"
                                    fullWidth
                                    className="custom-textfield"
                                    value={formData.RoomTypeName}
                                    onChange={handleInputChange}
                                    disabled={true}
                                    inputRef={RoomBedTypeRef}
                                    onKeyDown={handleKeyPress}
                                />
                            </Grid>

                            <Grid item xs={12} md={3} className="form_field">
                                <TextField
                                    id="RoomBedId"
                                    name="RoomBedId"
                                    label={
                                        <span>
                                            Bed No <span style={{ color: "red" }}>*</span>
                                        </span>
                                    }
                                    variant="filled"
                                    fullWidth
                                    className="custom-textfield"
                                    value={formData.RoombedName}
                                    onChange={handleInputChange}
                                    disabled={true}
                                    error={error.RoombedName}
                                    helperText={error.RoombedName ? "" : ""}
                                    inputRef={RoomBedIdRef}
                                    onKeyDown={handleKeyPress}
                                />
                            </Grid>

                            <Grid item xs={12} md={6} lg={3} className="form_field">
                                <TextField
                                    id="ResidentName"
                                    name="ResidentName"
                                    label="Resident Name"
                                    variant="filled"
                                    fullWidth
                                    className="custom-textfield"
                                    value={formData.ResidentName}
                                    onChange={handleInputChange}
                                    disabled={true}
                                    InputProps={{
                                        readOnly: true,
                                    }}
                                />
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid item xs={12} className="form_field">
                        <Grid container spacing={1} justifyContent="center">
                            <Grid item xs={12} md={3} className="form_field">
                                <CustomAutocomplete
                                    options={Topupsdrp}
                                    id="MstTopUpId-autocomplete"
                                    name="MstTopUpId"
                                    label="Topup Days"
                                    value={Topupsdrp.find((topup) => topup.TopupID === formData.MstTopUpId) || null}
                                    onChange={handleTopupsChange}
                                    disabled={isFormDisabled}
                                    error={error.TopupID}
                                    helperText={error.TopupID ? "" : ""}
                                    ref={MstTopUpIdRef}
                                    onKeyDown={handleKeyPress}
                                    getOptionLabel={(option) => option.TopupID || ""}
                                />
                            </Grid>

                            <Grid item xs={12} md={3} className="form_field">
                                <TextField
                                    id="TopUpAmt"
                                    name="TopUpAmt"
                                    label={
                                        <span>
                                            TopUpAmt <span style={{ color: "red" }}>*</span>
                                        </span>
                                    }
                                    variant="filled"
                                    fullWidth
                                    className="custom-textfield"
                                    value={formData.TopUpAmt}
                                    onChange={handleInputChange}
                                    disabled={true}
                                    error={error.TopUpAmt}
                                    helperText={error.TopUpAmt ? "" : ""}
                                    inputRef={TopUpAmtRef}
                                    onKeyDown={handleKeyPress}
                                />
                            </Grid>

                            <Grid item xs={12} md={3} className="form_field">
                                <TextField
                                    id="PytAdvId"
                                    name="PytAdvId"
                                    label="PytAdv No"
                                    variant="filled"
                                    fullWidth
                                    className="custom-textfield"
                                    value={formData.PytAdvNo}
                                    onChange={handleInputChange}
                                    disabled={true}
                                    error={error.PytAdvNo}
                                    helperText={error.PytAdvNo ? "" : ""}
                                    inputRef={PytAdvIdRef}
                                    onKeyDown={handleKeyPress}
                                />
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid item xs={12} className="form_field">
                        <Grid container spacing={1} justifyContent="center">
                            <Grid item xs={12} md={6} lg={6} className="form_field">
                                <TextField
                                    id="Remark"
                                    name="Remark"
                                    label="Remark"
                                    variant="filled"
                                    fullWidth
                                    className="custom-textfield"
                                    value={formData.Remark}
                                    onChange={handleInputChange}
                                    disabled={isFormDisabled}
                                    inputRef={RemarkRef}
                                    onKeyDown={handleKeyPress}
                                />
                            </Grid>

                            <Grid item xs={12} md={1.5} lg={1.5} className="form_field">
                                <FormGroup>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                disabled={isFormDisabled}
                                                checked={Status === "1"}
                                                onChange={handleChangeStatus}
                                            />
                                        }
                                        label="Status"
                                    />
                                </FormGroup>
                            </Grid>
                            <Grid item xs={12} md={1.5} lg={1.5} className="form_field">
                                <FormGroup>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={autoMail}
                                                onChange={handleAutoMail}
                                                disabled={isFormDisabled}
                                            />
                                        }
                                        label="AutoMail"
                                    />
                                </FormGroup>
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid item xs={12} className="form_button">
                        {mode === "view" && (
                            <>
                                <Button
                                    variant="contained"
                                    sx={{
                                        mr: 1,
                                        background: "linear-gradient(290deg, #d4d4d4, #d4d4d4)",
                                    }}
                                    onClick={handleAdd}
                                    disabled
                                >
                                    Submit
                                </Button>
                                <Button
                                    variant="contained"
                                    sx={{
                                        mr: 1,
                                        background: "linear-gradient(290deg, #b9d0e9, #e9f2fa)",
                                    }}
                                    onClick={handleEdit}
                                    disabled
                                >
                                    Cancel
                                </Button>
                            </>
                        )}
                        {(mode === "edit" || mode === "add") && (
                            <>
                                <Button variant="contained" sx={{ mr: 1 }} onClick={handleSave}>
                                    Submit
                                </Button>
                                <Button
                                    variant="contained"
                                    sx={{ mr: 1 }}
                                    onClick={handleCancel}
                                >
                                    Cancel
                                </Button>
                            </>
                        )}
                    </Grid>
                </Grid>
            </Box>

            <Box sx={{ display: 'none' }}>
                <TopupPrint
                    propId={PropId}
                    TopupID={currentTrnTopUpId}
                    formData={formData}
                    contentRef={contentRef}
                />
            </Box>

            <Dialog
                open={openConfirmDialog}
                onClose={handleCloseConfirmDialog}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">{"Confirm Deletion"}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Are you sure you want to delete this record?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button
                        sx={{
                            backgroundColor: "#635bff",
                            color: "white",
                            "&:hover": {
                                backgroundColor: "#1565c0",
                                color: "white",
                            },
                        }}
                        onClick={handleConfirmDelete}
                    >
                        Yes
                    </Button>
                    <Button
                        sx={{
                            backgroundColor: "#635bff",
                            color: "white",
                            "&:hover": {
                                backgroundColor: "#1565c0",
                                color: "white",
                            },
                        }}
                        onClick={handleCloseConfirmDialog}
                    >
                        No
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default TrnTopUp;